import { render, staticRenderFns } from "./MultiRootWrapper.vue?vue&type=template&id=0af37d1c&scoped=true&"
import script from "./MultiRootWrapper.vue?vue&type=script&lang=js&"
export * from "./MultiRootWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MultiRootWrapper.vue?vue&type=style&index=0&id=0af37d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af37d1c",
  null
  
)

export default component.exports